// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"100":"Land","708":"Landing"}[chunkId] || chunkId) + "." + {"100":"998a60d0","283":"e84fde46","708":"16e7db47"}[chunkId] + ".chunk.css";
};